import { useState } from 'react';
import { Phone, Copy, X, Check } from 'lucide-react';
import { Button } from './ui/button';

const DISPLAY_NUMBER = '(914) 266-0223';
const COPY_NUMBER = '9142660223';

/**
 * Detects if the device is a touch/mobile device using capability detection
 * rather than screen width alone. This correctly handles iPads and large phones.
 */
export const isTouchDevice = () => {
  if (typeof window === 'undefined') return false;
  const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
  const hasTouchPoints = navigator.maxTouchPoints > 0;
  const hasTouchEvent = 'ontouchstart' in window;
  return hasCoarsePointer || hasTouchPoints || hasTouchEvent;
};

export const CallModal = ({ isOpen, onClose }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(COPY_NUMBER);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const textArea = document.createElement('textarea');
      textArea.value = COPY_NUMBER;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center" data-testid="call-modal-overlay">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full mx-4 animate-in fade-in zoom-in-95 duration-200" data-testid="call-modal">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          data-testid="call-modal-close"
        >
          <X className="h-5 w-5" />
        </button>

        {/* Content */}
        <div className="text-center">
          <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Phone className="h-7 w-7 text-blue-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-1">Call TruBridge Health</h3>
          <p className="text-2xl font-bold text-blue-600 mb-6">{DISPLAY_NUMBER}</p>

          <div className="flex flex-col gap-3">
            <Button
              onClick={handleCopy}
              className={`w-full py-5 text-base font-semibold transition-all ${
                copied
                  ? 'bg-green-600 hover:bg-green-700 text-white'
                  : 'bg-blue-600 hover:bg-blue-700 text-white'
              }`}
              data-testid="call-modal-copy-btn"
            >
              {copied ? (
                <>
                  <Check className="mr-2 h-5 w-5" />
                  Copied!
                </>
              ) : (
                <>
                  <Copy className="mr-2 h-5 w-5" />
                  Copy Phone Number
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { DISPLAY_NUMBER };
